export default function passwordOverlay() {
	const overlay = document.querySelector('.password-overlay');

	if (!overlay) {
		return;
	}

	const input = overlay.querySelector('.password-overlay__input');
	const toggle = overlay.querySelector('.password-overlay__toggle');

	if (input) {
		input.focus();
	}

	if (!input || !toggle) {
		return;
	}

	toggle.addEventListener('click', () => {
		const isPassword = input.type === 'password';

		input.type = isPassword ? 'text' : 'password';
		toggle.setAttribute('aria-pressed', isPassword ? 'true' : 'false');
		toggle.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
	});
}
